export default __webpack_public_path__ + "static/media/illustration-easy-to-implement.07edaff0.svg";